import script from "./ExamRecommendationList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExamRecommendationList.vue?vue&type=script&setup=true&lang=ts"

import "./ExamRecommendationList.vue?vue&type=style&index=0&id=1af7f2b7&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1af7f2b7"]])

export default __exports__